<template>
    <v-sheet>
        <div class="d-flex align-center" style="position: relative">
            <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">입금하실 계좌</h5>
        </div>
        <vertical-form-table :value="form" v-bind="{ items }" mode="view"></vertical-form-table>
    </v-sheet>
</template>

<script>
import { initPointForm__account } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "meta.bank.name",
        type: "text",
        term: "은행명",
    },
    {
        key: "meta.bank.accountHolder",
        type: "text",
        term: "예금주",
    },
    {
        key: "meta.bank.accountNumber",
        type: "text",
        term: "계좌번호",
    },
];

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        form: { type: Object, default: initPointForm__account },
    },
    data: () => ({
        items,
    }),
};
</script>

<style>
</style>